import axios from 'axios'
import { handleSuccess, handleError } from './axiosHandler';
import { authHeader, authHeaderJson } from '../_helpers/auth-header';

import  config  from '../config';
const base_url = config.apiUrl;

const model = 'Personnels/';

export const personnelsService = {
  getAll,
  getById,
  add,
  edit,
  delete: _delete,
};

function getAll() {
  const url = base_url + model;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}

function getById(id) {
  const url = base_url + model + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}

function add(dto) {
  const url = base_url + model;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.post(url, dto, { headers: authHeaderJson()});
}

function edit(id, dto) {
  const url = base_url + model + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.put(url, dto, { headers: authHeaderJson()});
}

function _delete(id) {
  const url = base_url + model + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.delete(url, { headers: authHeader()});
}
